import React, {useEffect} from 'react';
import {
    readCollapsedPreference,
    viewportRange,
    RANGE_MOBILE,
    RANGE_DESKTOP,
} from '../../../context/SidebarContext';

/**
 * Lo que se ve mientras baja el chunk de `AppChromeV2` (que es lazy para que el marco nuevo no
 * viaje en el bundle de las agencias fuera del piloto).
 *
 * Antes el fallback era `null`, y el problema no era el hueco: TODO el offset de las pantallas
 * cuelga de las clases que `AppChromeV2` pone en el <body> (`_ui-v2.scss`). Sin ellas, la primera
 * navegación de la sesión pintaba la pantalla pegada al borde izquierdo y bajo el borde superior, y
 * cuando el chunk llegaba el contenido entero saltaba 240px a la derecha y 56px hacia abajo.
 *
 * Así que este componente hace dos cosas: pone las mismas clases (el hueco queda reservado desde el
 * primer frame) y dibuja las dos cajas vacías del marco, para que la transición no sea "sin marco →
 * con marco" sino "marco vacío → marco".
 *
 * NO limpia las clases al desmontarse a propósito: quien lo reemplaza es `ChromeBody`, que las
 * vuelve a poner en su propio efecto. Sacarlas acá sólo agregaría el parpadeo que vino a evitar.
 */
export function AppChromeV2Skeleton() {
    // El provider real todavía no existe (vive dentro del chunk), así que el ancho a reservar se
    // resuelve con los mismos helpers que usa él — no con constantes copiadas, que se desincronizan.
    const range = viewportRange();
    const isMobile = range === RANGE_MOBILE;
    const isCollapsed = range === RANGE_DESKTOP ? readCollapsedPreference() : !isMobile;

    useEffect(() => {
        document.body.classList.add('ui-v2');
        document.body.classList.toggle('ui-v2-collapsed', isCollapsed && !isMobile);
        document.body.classList.toggle('ui-v2-mobile', isMobile);
    }, [isCollapsed, isMobile]);

    return (
        <>
            <aside
                className={`sidebar-v2${isCollapsed && !isMobile ? ' collapsed' : ''}${isMobile ? ' mobile' : ''}`}
                aria-hidden="true"
            />
            <div className="topbar" aria-hidden="true"/>
        </>
    );
}

export default AppChromeV2Skeleton;
